import React, {useContext} from 'react'
import { MainContext } from '../App'
import history from '../history'
import Button from '@material-ui/core/Button'

export default function Root() {
  const { user } = useContext(MainContext);
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      height: "200px",
      alignItems: "center",
      justifyContent: "center"
    }}>
    { user ? (
      <div>
        Bem-vindo, <b>{user.alias}</b>!
      </div>
    ):(
      <>
      <div>
        Você não está autenticado na aplicação!
      </div>
      <div>
        <Button variant="outline" onClick={() => history.push("/logon")}>
          Ir para página de autenticação
        </Button>
      </div>
      </>
    )}
    </div>
  )
}
